var _g, _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgVacant = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0Vacant)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 20,
    r: 16,
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4561 21.9979H31.8695C31.616 21.9997 31.3864 21.8576 31.277 21.6313L30.5289 20.0716C30.313 19.6186 29.8567 19.3321 29.3507 19.3318H25.5107C25.091 19.3318 24.6918 19.5293 24.4331 19.865L23.125 21.5647C22.9087 21.8424 22.5938 22.0267 22.2478 22.0779L19.2986 22.5311C18.6184 22.6062 18.0944 23.1816 18.0846 23.8642L18.0546 25.3305C18.047 25.6986 18.3394 25.9971 18.7076 25.9971H19.3743C19.3592 26.7333 19.9439 27.3301 20.6803 27.3301C21.4167 27.3301 22.0258 26.7333 22.0409 25.9971H29.3743C29.3592 26.7333 29.9439 27.3301 30.6803 27.3301C31.4167 27.3301 32.0258 26.7333 32.0409 25.9971H32.0809C32.493 25.9986 32.9016 25.9027 33.2733 25.7171L33.6841 25.5172C33.9128 25.4031 34.0596 25.1707 34.063 24.9173L34.1092 22.6644C34.1167 22.2963 33.8243 21.9979 33.4561 21.9979Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6924 19.7739C21.6899 19.8978 21.5873 19.9983 21.4634 19.9983H21.0144C20.8905 19.9983 20.792 19.8978 20.7946 19.7739L20.8038 19.3251C20.8063 19.2011 20.9088 19.1006 21.0328 19.1006H21.4817C21.6057 19.1006 21.7042 19.2011 21.7016 19.3251L21.6924 19.7739Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0583 16.2101C23.0431 16.7694 22.6711 17.2633 22.1354 17.4355L21.7374 17.5746C21.7155 17.5837 21.7009 17.6049 21.7004 17.6285L21.6933 17.9786C21.6907 18.1025 21.5882 18.203 21.4642 18.203H21.123C20.999 18.203 20.9006 18.1025 20.9031 17.9786L20.9103 17.6285C20.9187 17.2653 21.1586 16.9435 21.5058 16.8295L21.9351 16.6904C22.1412 16.6195 22.2822 16.4266 22.2861 16.2101L22.2913 15.9588C22.2942 15.8223 22.2414 15.6916 22.1451 15.5968C22.0489 15.502 21.9174 15.4512 21.7808 15.4561H20.883C20.6053 15.4561 20.3755 15.6812 20.3699 15.9588L20.3653 16.1832C20.3627 16.3072 20.2602 16.4076 20.1362 16.4076H19.795C19.671 16.4076 19.5726 16.3072 19.5751 16.1832L19.5797 15.9588C19.5944 15.2449 20.1851 14.6661 20.8991 14.6661H21.797C22.1399 14.6661 22.466 14.8023 22.7035 15.0447C22.941 15.2872 23.0705 15.616 23.0635 15.9588L23.0583 16.2101Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0Vacant",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0.294118 0 0 0 0 0.352941 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVacant, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Vacant.9ab72d99.svg";
export { ForwardRef as ReactComponent };